import { DATE_FORMAT } from '@cl/shared/constants';
import { BaseModel, EntityType } from '@cl/shared/models';
import { NzModalRef } from 'ng-zorro-antd/modal';

export abstract class BaseViewEntityComponent<T extends BaseModel> {
    EntityType = EntityType;
    DATE_FORMAT: string = DATE_FORMAT;

    entity: T;

    loading: boolean = false;

    constructor(protected modalRef: NzModalRef) {}

    close(): void {
        this.modalRef.close();
    }
}
